/* Mouse drag-to-swipe for every horizontal rail: PDP gallery / Pairs / More / strap chips / size guide, home rails, the-straps, atelier,
   about-us, blog, partnerships, cart. Touch already scrolls natively and is never touched here (pointerType 'mouse' only).
   With a mouse the browser picked up the image/link (native drag ghost) instead of scrolling.
   Rails with scroll-snap: snap off during the drag, then glide to the nearest slide. Rails without: short momentum.
   Other rails: add the attribute data-drag-scroll. Loaded site-wide by layout/theme.liquid (and still by main-product.liquid): the flag keeps it to one copy.
   Own handlers stay as they are: boutique photo rail, our-story [data-strip], collection card galleries (.pc__g), flipbook. */
(function () {
  if (window.bbDragScroll) return; window.bbDragScroll = 1;
  var SEL = ['.ph-gallery__track', '.rc-track', '.oc-track', '.bb-rail', '.bb-pdp-guide__sc',
    '.bbh-piece .cp__tr', '.bbh-occasions .oc', '.bbh-jewellery .jr', '.bbh-jewellery .jr__g', '.bbh-packshots .pk2',
    '#lineup .ln__row', '.hw__g.rail', '.wd__g.rail', 'ol.stp', '.rv__l', '.hc2-rail', '.tr__g', '.bbp-pf .fm', '.bbp-ct .xs__r',
    '[data-drag-scroll]'].join(',');
  var OWN = '.bbj [data-rail]';   /* blog rail: its template still has an older mouse handler, switched off below so the two never fight */
  var MOVE = 10;                  /* px before a press counts as a drag; below that it stays a click (7px of hand wobble must still click) */
  var st = document.createElement('style');
  st.textContent = '.bb-ds img,.bb-ds a{-webkit-user-drag:none}@media (hover:hover){.bb-ds{cursor:grab}}' +
    '.bb-ds.is-drag{scroll-snap-type:none!important;scroll-behavior:auto!important;user-select:none;-webkit-user-select:none}' +
    '.bb-ds.is-drag,.bb-ds.is-drag *{cursor:grabbing!important}';
  document.head.appendChild(st);

  var s = null, anim = null, noClick = 0;   /* s = the press on a rail; anim = running glide / momentum; noClick = swallow the click that ends a drag */

  /* rails: a rail only counts while it really scrolls sideways (static layouts keep their normal cursor and native image drag) */
  function can(g) { return /auto|scroll/.test(getComputedStyle(g).overflowX) && g.scrollWidth > g.clientWidth + 2; }
  function chain(t) { var a = [], g = t.closest && t.closest(SEL); while (g) { a.push(g); g = g.parentElement && g.parentElement.closest(SEL); } return a; }
  function railAt(t) { return chain(t).filter(can)[0]; }
  var ro = window.ResizeObserver && new ResizeObserver(function (l) { l.forEach(function (r) { mark(r.target); }); });
  function mark(g) { if (!g.dataset.bbDs) { g.dataset.bbDs = '1'; if (ro) ro.observe(g); } g.classList.toggle('bb-ds', can(g)); }
  function scan() { document.querySelectorAll(SEL).forEach(mark); }
  var rz = 0;
  scan(); addEventListener('load', scan);
  addEventListener('resize', function () { cancelAnimationFrame(rz); rz = requestAnimationFrame(scan); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(scan);
  document.addEventListener('mouseover', function (e) { chain(e.target).forEach(mark); }, true);   /* rails that appear later (JS-built, drawer, tabs) */

  /* snap points: children with a scroll-snap-align (looks through display:contents wrappers); [element, start|center|end] */
  function targets(g) {
    var out = [];
    (function walk(p) { [].forEach.call(p.children, function (c) {
      var cs = getComputedStyle(c);
      if (cs.display === 'contents') walk(c);
      else if (cs.scrollSnapAlign !== 'none' && c.offsetWidth) out.push([c, cs.scrollSnapAlign.split(' ').pop()]);
    }); })(g);
    return out;
  }
  /* how far (px) a snap point is from where the rail's snapport would hold it */
  function off(o, c) {
    var g = o.g, r = c[0].getBoundingClientRect(), b = g.getBoundingClientRect();
    if (c[1] === 'center') return r.left + r.width / 2 - (b.left + o.pl + (g.clientWidth - o.pl - o.pr) / 2);
    if (c[1] === 'end') return r.right - (b.left + g.clientWidth - o.pr);
    return r.left - b.left - o.pl;
  }
  function nearest(o) { var best = 0, bd = 1e9; o.snap.forEach(function (c, i) { var d = Math.abs(off(o, c)); if (d < bd) { bd = d; best = i; } }); return best; }

  function stopAnim() { if (anim) { cancelAnimationFrame(anim.id); anim = null; } }
  /* own frame-driven motion: the browser's smooth scroll got cut off when snap came back and ended on the wrong slide */
  function run(g, snap, step) {
    var t = performance.now(); anim = { g: g, snap: snap };
    (function frame(now) {
      var a = anim, more = step(now - t, now); t = now;
      if (more) a.id = requestAnimationFrame(frame); else { g.classList.remove('is-drag'); if (anim === a) anim = null; }
    })(t);
  }

  function begin(o) {
    var g = o.g;
    if (!o.snap) o.snap = getComputedStyle(g).scrollSnapType !== 'none' ? targets(g) : [];   /* read before the class below switches snap off */
    o.i0 = o.snap.length ? nearest(o) : 0;
    g.classList.add('is-drag');
  }

  function end(e) {
    if (!s) return;
    var o = s, g = o.g; s = null;
    if (!o.on && !o.res) return;   /* a plain click: nothing to do */
    if (o.on) { noClick = 1; setTimeout(function () { noClick = 0; }, 0); }
    var max = g.scrollWidth - g.clientWidth;
    if (o.snap.length) {   /* glide to the nearest slide start */
      var d = g.scrollLeft - o.l0, j = nearest(o), nb = o.snap[j + (d > 0 ? 1 : -1)];
      /* still on the same slide: a pull of 15% of a slide, or a short fast flick, goes one slide on */
      if (nb && j === o.i0 && (Math.abs(d) > .15 * Math.abs(off(o, nb) - off(o, o.snap[j])) || Math.abs(d) > 20 && Date.now() - o.t < 300)) j += d > 0 ? 1 : -1;
      var from = g.scrollLeft, to = Math.max(0, Math.min(max, from + off(o, o.snap[j]))), t1 = performance.now();
      if (Math.abs(to - from) < 1) { g.classList.remove('is-drag'); return; }
      run(g, o.snap, function (dt, now) { var k = Math.min(1, (now - t1) / 260); g.scrollLeft = from + (to - from) * (1 - Math.pow(1 - k, 3)); return k < 1; });
      return;
    }
    /* free rail: carry on with the speed of the last 100ms, fading out; none if the hand stopped before letting go */
    var n = o.m.length, last = o.m[n - 1], first = n && o.m.filter(function (p) { return last[0] - p[0] <= 100; })[0], now = (e && e.timeStamp) || performance.now();
    var v = n > 1 && now - last[0] < 80 && last[0] > first[0] ? (last[1] - first[1]) / (last[0] - first[0]) : 0, pos = g.scrollLeft;
    v = Math.max(-3, Math.min(3, v));
    if (Math.abs(v) < 0.05) { g.classList.remove('is-drag'); return; }
    run(g, [], function (dt) { pos = Math.max(0, Math.min(max, pos + v * dt)); g.scrollLeft = pos; v *= Math.pow(0.92, dt / 16); return Math.abs(v) > 0.03 && pos > 0 && pos < max; });
  }

  addEventListener('pointerdown', function (e) {   /* window + capture: other scripts stop the event before it reaches the rail */
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var g = railAt(e.target);
    if (!g || e.target.closest('input,textarea,select,[contenteditable]')) return;
    var b = g.getBoundingClientRect();
    if (e.clientX - b.left > g.clientWidth || e.clientY - b.top > g.clientHeight) return;   /* on the rail's own scrollbar */
    var cs = getComputedStyle(g);
    s = { g: g, x: e.clientX, l: g.scrollLeft, l0: g.scrollLeft, t: Date.now(), on: false, m: [], pl: parseFloat(cs.scrollPaddingLeft) || 0, pr: parseFloat(cs.scrollPaddingRight) || 0 };
    if (anim && anim.g === g) { stopAnim(); s.snap = anim.snap; s.res = 1; }   /* pressed again during a glide: take it from here */
    if (g.matches(OWN)) e.stopImmediatePropagation();
  }, true);
  addEventListener('pointermove', function (e) {
    if (!s || e.pointerType !== 'mouse') return;
    if (!(e.buttons & 1)) { end(e); return; }   /* the button was let go outside the window */
    if (!s.on) {
      if (Math.abs(e.clientX - s.x) < MOVE) return;
      s.on = true; s.x = e.clientX; s.l = s.g.scrollLeft; s.t = Date.now(); begin(s);   /* grab from here: the rail does not jump by the first 10px */
    }
    s.g.scrollLeft = s.l - (e.clientX - s.x);
    s.m.push([e.timeStamp, s.g.scrollLeft]); if (s.m.length > 6) s.m.shift();
  });
  addEventListener('pointerup', end); addEventListener('pointercancel', end); addEventListener('blur', function () { end(); });
  addEventListener('dragstart', function (e) { if (railAt(e.target)) e.preventDefault(); }, true);   /* no native image / link drag */
  addEventListener('selectstart', function (e) { if (s) e.preventDefault(); }, true);                  /* no text selection while dragging */
  addEventListener('click', function (e) { if (noClick) { e.preventDefault(); e.stopPropagation(); } }, true);
})();
